// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__31EH5","inputWrap":"CustomTip_inputWrap__knfMu"};